// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { wishListCardStyles } from "@vanmeter/Overrides/Components/WishListCard";
import { constants, fontConfig } from "@vanmeter/XDL/constants";
import { color, ellipsis, moreActionsSharedStyle, xScreen } from "@vanmeter/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";
import { IconWrapper } from "@insite/mobius/Icon";
import Star from "@vanmeter/XDL/Icons/Star";
import StarX from "@vanmeter/XDL/Icons/StarX";

wishListCardStyles.gridContainer = {
    css: css`
        display: grid;
        grid-column-gap: 22px;
        justify-content: space-between;
        grid-template-columns: minmax(0, 300px) 300px minmax(100px, 1fr) 200px;

        ${xScreen("lte", constants.Dashboard.breakpoints.md)} {
            grid-template-columns: minmax(317px, 1fr) minmax(0, 1fr);
        }
        ${xScreen("lte", "sm")} {
            grid-template-columns: 1fr;
        }
        grid-row-gap: 12px;
        width: 100%;
    `,
};

wishListCardStyles.descriptionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

wishListCardStyles.nameWrapper = {
    css: css`
        display: flex;
        ${TypographyStyle} {
            font-size: ${fontConfig.smallSingleLine.size}px;
            line-height: ${fontConfig.smallSingleLine.lineHeight};
            ${ellipsis(1)}
        }
    `,
};

wishListCardStyles.lastUpdatedText = { ...fontConfig.xSmall };

wishListCardStyles.descriptionText = {
    ...fontConfig.xSmall,
    css: css`
        ${ellipsis(3)}
    `,
};

wishListCardStyles.productImagesGridItem = {
    css: css`
        display: flex;
        gap: 12px;
    `,
};

wishListCardStyles.productImageLink = {};

wishListCardStyles.productImage = {
    width: "91px",
    css: css`
        img {
            max-width: 100%;
            max-height: 100%;
            height: auto;
            aspect-ratio: 1;
        }
    `,
};

wishListCardStyles.sharingStatusGridItem = {
    css: css`
        width: 100%;
    `,
};

wishListCardStyles.favTagsWrapper = {
    css: css`
        display: flex;
        column-gap: 24px;
        flex-wrap: wrap;
        &:empty {
            display: none;
        }
    `,
};

wishListCardStyles.actionFavoriteClickable = {
    css: css`
        width: auto;
        gap: 6px;
        color: ${color("primary")};
        font-size: ${fontConfig.xSmall.size}px;
        line-height: ${fontConfig.xSmall.lineHeight};

        &:hover {
            &,
            & > ${IconWrapper} {
                color: ${color("common.ui15")};
            }
        }
    `,
};

const iconDefaults = { color: "primary", size: 14 };

wishListCardStyles.starIcon = { ...iconDefaults, src: Star };
wishListCardStyles.starXIcon = { ...iconDefaults, src: StarX };
wishListCardStyles.tagIcon = { ...iconDefaults, src: "Tag" };

wishListCardStyles.actionAddToCartButton = {
    variant: "tertiary",
    css: css`
        white-space: nowrap;
        width: 100%;
    `,
};

wishListCardStyles.actionOverflowMenu = {
    ...moreActionsSharedStyle.overflowMenu,
};

wishListCardStyles.moreActionsLink = {
    ...moreActionsSharedStyle.moreActionsLink,
};

wishListCardStyles.actionGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        width: 100%;
        align-items: flex-end;
    `,
};
